module.exports = __webpack_public_path__ + "img/join-banner.df5a19a6.jpg";